import ComponentBase from "./componentBase";

type arrayParagraph = string[]; 
export default abstract class TextSliderBase extends ComponentBase{
    private currentSlide:number;
    private numSlide:number;
    private slideContainer:HTMLElement;
    private spanAmountSlide:HTMLElement;
    private btnPrev:HTMLElement;
    private btnNext:HTMLElement;

    constructor(
        protected idSlide:string,
        protected parentElement:HTMLElement,
        protected contents:arrayParagraph[],
        protected elementToRender:string
    ){
        super(parentElement,idSlide,elementToRender);
        this.currentSlide = 0;
    }

    public renderSlide(){
        this.renderWithCB(()=>{
            this.slideContainer = this.elementRendered.querySelector(".slider-container");
            this.spanAmountSlide = this.elementRendered.querySelector(".slide-legend");
            this.btnPrev = this.elementRendered.querySelector(".prev");
            this.btnNext = this.elementRendered.querySelector(".next");

            this.btnNext.addEventListener("click",()=>{
                this.nextSlide()
            });
            this.btnPrev.addEventListener("click",()=>{
                this.prevSlide();
            });

            this.startSlide();
        });
    }

    private startSlide(){
        this.numSlide = this.contents.length;
        this.UpdateLegend();
    }

    private nextSlide(){
        if(this.currentSlide<this.numSlide-1){
            this.currentSlide++;
            this.UpdateLegend();
        }
    }

    private prevSlide(){
        this.currentSlide--;
        if(this.currentSlide<0){
            this.currentSlide = 0;
        }
        
        this.UpdateLegend();
    }

    private loadContentSlide(){
        this.slideContainer.innerHTML = this.contents[this.currentSlide].map((element)=>`<p>${element}</p>`).join("");
    }

    private UpdateLegend(){
        this.spanAmountSlide.textContent = `${this.currentSlide+1}/${this.numSlide}`;
        this.loadContentSlide();
    }
}